import { EGenplanInfrastructureCategory } from '../newbuilding/genplan';

export interface IProduct {
  offerType?: string | null;
  brand?: string | null;
  consultant?: boolean | null;
  dealType?: string | null;
  id?: number | null;
  name?: string | null;
  nv?: boolean | null;
  objectType?: string | null;
  position?: number | null;
  extra?: TExtra;
}

export enum EGenplanControlsType {
  Floor = 'on_floor',
  Panorama = 'panorama',
}

export type TExtra =
  | {
      cplCalltracking?: number;
      cplDynamicCalltracking?: number;
    }
  | {
      corpus_id?: number;
    }
  | {
      corpus_id?: number;
      room_num?: string;
    }
  | {
      type: EGenplanControlsType | EGenplanInfrastructureCategory;
    }
  | {
      promoId: number;
      promoCianMortgage: string;
    }
  | {
      label: string;
      promotion_id: number;
    };
